import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { Icon, IconButton, Link, Menu, MenuItem } from '@material-ui/core'
import { useReactiveVar } from '@apollo/client'
import { appSubdomainVar, isUserLoggedInVar } from '../../graphql/stores/local'
import { DIGIKAPITAAL_SUBDOMAIN_NAME, SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME } from '../../constants'
import * as internalRoutes from '../../constants/internaRoutes'

const listRoutes = [
  { href: internalRoutes.registerSchool, title: 'Register new school' },
  {
    href: internalRoutes.create.multischoolReport,
    title: 'Create combined report',
    subDomain: DIGIKAPITAAL_SUBDOMAIN_NAME,
  },
  { href: internalRoutes.create.answer, title: 'Create answer' },
  {
    href: internalRoutes.create.question,
    title: 'Create question',
    subDomain: DIGIKAPITAAL_SUBDOMAIN_NAME,
  },
  {
    href: internalRoutes.create.schoolleaderQuestion,
    title: 'Create question',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
  { href: internalRoutes.create.session, title: 'Sessie creeren' },
  { href: internalRoutes.create.form, title: 'Formulierenbouwer' },
  {
    href: internalRoutes.create.schoolleader,
    title: 'Create school leaders',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
  {
    href: internalRoutes.create.group,
    title: 'Create schoolleader group',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
  {
    href: internalRoutes.create.statisticGroups,
    title: 'Create statistic groups',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
]

const AddContent = () => {
  const isUserLoggedIn = useReactiveVar(isUserLoggedInVar)
  const subDomain = useReactiveVar(appSubdomainVar)
  const { t } = useTranslation()
  const location = useLocation()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleToggle = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  if (location.pathname !== '/login')
    return (
      isUserLoggedIn && (
        <div>
          <IconButton
            aria-label="add-menu"
            aria-controls="menu-appbar-add"
            aria-haspopup="true"
            onClick={handleToggle}
            color="inherit"
          >
            <Icon children={'add'} />
          </IconButton>
          <Menu
            id="menu-appbar-add"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            onClose={handleClose}
          >
            {listRoutes.map((item, key) => {
              if (subDomain === item.subDomain || !item.subDomain)
                return (
                  <MenuItem key={key}>
                    <Link href={item.href}>{t(item.title)}</Link>
                  </MenuItem>
                )
              else return null
            })}
          </Menu>
        </div>
      )
    )
  else return null
}

export default AddContent
